import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import ModuleDisabled from '../components/ModuleDisabled.jsx'
import { MODULES_BY_KEY } from '../modules/registry.js'

export function RequireAuth({ user }) {
  if (!user) return <Navigate to="/auth" replace />
  return <Outlet />
}

export function RequireRole({ user, allowed }) {
  const ok = !!(user && Array.isArray(user.roles) && user.roles.some((r) => allowed.includes(r)))
  if (!ok) return <Navigate to="/orders" replace />
  return <Outlet />
}

export function RequireModule({ enabled, moduleKey, canManage }) {
  if (enabled == null) return <Outlet />
  if (!enabled) {
    const label = MODULES_BY_KEY[moduleKey]?.label || moduleKey
    return <ModuleDisabled moduleLabel={label} canManage={canManage} />
  }
  return <Outlet />
}
